import api from './api';

export const login = async (credentials) => {
  const response = await api.post('/auth/login', credentials);
  return response;
};

export const register = async (userData) => {
  const response = await api.post('/auth/register', userData);
  return response;
};

export const changePassword = async (passwordData) => {
  const response = await api.put('/auth/change-password', passwordData);
  return response;
};

export const getPendingRegistrations = async () => {
  const response = await api.get('/auth/pending-registrations');
  return response;
};

export const approveRegistrationRequest = async (requestId, action, adminNotes = '') => {
  const response = await api.put(`/auth/approve-registration/${requestId}`, { action, adminNotes });
  return response;
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

export const forgotPassword = async (email) => {
  const response = await api.post('/auth/forgot-password', { email });
  return response;
};

export const resetPassword = async (token, password, confirmPassword) => {
  const response = await api.post('/auth/reset-password', { token, password, confirmPassword });
  return response;
}; 